<template>
    <div>
        <table :class="tableClass">
            <caption>{{this.$t('Calculette.result.donneesEntree')}}</caption>
            <thead class="hidden">
                <tr>
                    <th scope="col">{{this.$t('general.donneesEntree')}}</th>
                    <th scope="col">{{this.$t('general.valeur')}}</th>
                </tr>
            </thead>
            <tbody>
            <tr>
                <td :class='colLeft'>{{ $t("Calculette.champs.periodeFiscale") }}</td>
                <td :class='colRight'>{{resultat.annee}}</td>
            </tr>
            <tr>
                <td :class="colLeft">{{ $t("Calculette.champs.bareme") }}</td>
                <td :class='colRight'>{{resultat.bareme}}</td>
            </tr>
            <tr>
                <td :class="colLeft">{{ $t("Calculette.champs.revenuContribuable") }}</td>
                <td v-if="resultat.revenuContribuableEUR" :class='colRight'>
                   <span v-html="getMontant(resultat.revenuContribuableCHF, resultat.revenuContribuableEUR, resultat.revenuContribuable)"></span>
                </td>
                <td v-else :class='colRight'>
                   {{formatCurrency(resultat.revenuContribuable)}}
                </td>
            </tr>
            <tr v-if="(resultat.isBaremeRectif || resultat.isBaremeAjuste)">
                <td :class="colLeft">{{ $t("Calculette.champs.revenuConjoint") }}</td>
                <td v-if="resultat.revenuConjointEUR" :class='colRight'>
                    <span v-html="getMontant(resultat.revenuConjointCHF, resultat.revenuConjointEUR, resultat.revenuConjoint)"></span>
                </td>
                <td v-else :class='colRight'>{{formatCurrency(resultat.revenuConjoint)}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CurrencyUtils from '../../../utils/CurrencyUtils';

export default {
  name: 'section-donnees-entree',
  props: ['resultat', 'colLeft', 'colRight', 'tableClass'],
  mixins: [CurrencyUtils],
  methods: {
    getMontant(revenuCHF, revenuEUR, revenuTotal) {
      if (revenuCHF > 0) {
        return `${this.formatCurrency(revenuCHF)} + ${
          this.formatCurrency(revenuEUR)
        } * ${this.resultat.tauxChange} = <strong> ${this.formatCurrency(revenuTotal)} </strong>`;
      }
      return `${
        this.formatCurrency(revenuEUR)
      } * ${this.resultat.tauxChange} = <strong> ${this.formatCurrency(revenuTotal)} </strong>`;
    },
  },
};
</script>

<style scoped>

</style>
